module.exports = __webpack_public_path__ + "static/media/news_05.55044d61.jpg";